export type Tokens = {
  refreshToken: string;
  accessToken: string;
  userToken: string;
};

enum LocalStorageKeys {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  USER_TOKEN = 'USER_TOKEN',
  IMPERSONATION = 'IMPERSONATION',
}

export type ImpersonationInfo = {
  impersonatorId: number;
  targetUserId: string;
  targetUserName: string;
  // The RM's own user token, kept so the session can be restored on logout.
  originalUserToken: string;
  sessionExpiresAt: string;
};

export function getAccessToken(): string | null {
  return localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(LocalStorageKeys.REFRESH_TOKEN);
}

export function getUserToken(): string | null {
  return localStorage.getItem(LocalStorageKeys.USER_TOKEN);
}

export function updateAccessToken(token: string): void {
  localStorage.setItem(LocalStorageKeys.ACCESS_TOKEN, token);
}

export function updateRefreshToken(token: string): void {
  localStorage.setItem(LocalStorageKeys.REFRESH_TOKEN, token);
}

export function updateUserToken(token: string): void {
  localStorage.setItem(LocalStorageKeys.USER_TOKEN, token);
}

export function getImpersonationInfo(): ImpersonationInfo | null {
  const raw = localStorage.getItem(LocalStorageKeys.IMPERSONATION);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ImpersonationInfo;
  } catch {
    return null;
  }
}

export function setImpersonationInfo(info: ImpersonationInfo): void {
  localStorage.setItem(LocalStorageKeys.IMPERSONATION, JSON.stringify(info));
}

export function clearImpersonationInfo(): void {
  localStorage.removeItem(LocalStorageKeys.IMPERSONATION);
}

// export function isImpersonating(): boolean {
//   return Boolean(getImpersonationInfo());
// }

export function signOut(): void {
  localStorage.clear();
}
